import React, { useState } from 'react';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';

const RelatorioFinanceiro = () => {
  const navigate = useNavigate();
  const [tipo, setTipo] = useState('fluxo');
  const [inicio, setInicio] = useState('');
  const [fim, setFim] = useState('');
  const [ano, setAno] = useState('');
  const [mes, setMes] = useState('');
  const [loading, setLoading] = useState(false);

  const gerarRelatorio = async () => {
    try {
      setLoading(true);
      let url = '';
      let params = {};

      if (tipo === 'fluxo') {
        if (!inicio || !fim) return alert('Informe o período.');
        url = '/relatoriofinanceiropdf/fluxo-caixa';
        params = { dataInicio: inicio, dataFim: fim };
      } else if (tipo === 'categoria') {
        if (!inicio || !fim) return alert('Informe o período.');
        url = '/relatoriofinanceiropdf/por-categoria';
        params = { dataInicio: inicio, dataFim: fim };
      } else if (tipo === 'consolidado') {
        if (!ano || !mes) return alert('Informe ano e mês.');
        url = '/relatoriofinanceiropdf/financeiro/consolidado';
        params = { ano, mes };
      }

      const response = await api.get(url, { params, responseType: 'blob' });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = urlBlob;
      link.download = `relatorio-${tipo}.pdf`;
      link.click();
      window.URL.revokeObjectURL(urlBlob);
    } catch (err) {
      console.error('Erro ao gerar relatório:', err);
      alert('Erro ao gerar o relatório.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
        <Header />
      <div className="card shadow border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button className="btn btn-light btn-sm d-flex align-items-center gap-1" onClick={() => navigate('/menu')}>  
              <i className="bi bi-arrow-left text-success"></i>
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <h5 className="mb-0">Relatório Financeiro (PDF)</h5>
          </div>
        </div>

        <div className="card-body">
          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Tipo de Relatório</label>
              <select className="form-select" value={tipo} onChange={e => setTipo(e.target.value)}>
                <option value="fluxo">Fluxo de Caixa</option>
                <option value="categoria">Totais por Categoria</option>
                <option value="consolidado">Consolidado Mensal</option>
              </select>
            </div>
          </div>

          {tipo === 'fluxo' || tipo === 'categoria' ? (
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className="form-label fw-semibold">Data Início</label>
                <input type="date" className="form-control" value={inicio} onChange={e => setInicio(e.target.value)} />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold">Data Fim</label>
                <input type="date" className="form-control" value={fim} onChange={e => setFim(e.target.value)} />
              </div>
            </div>
          ) : tipo === 'consolidado' ? (
            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="form-label fw-semibold">Ano</label>
                <input type="number" className="form-control" value={ano} onChange={e => setAno(e.target.value)} />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Mês</label>
                <select className="form-select" value={mes} onChange={e => setMes(e.target.value)}>
                  <option value="">Selecione</option>
                  {Array.from({ length: 12 }, (_, i) => i + 1).map(m => (
                    <option key={m} value={m}>{m.toString().padStart(2, '0')}</option>
                  ))}
                </select>
              </div>
            </div>
          ) : null}

          <div className="row mt-4">
            <div className="col-md-4 d-grid">
              <button className="btn btn-success" onClick={gerarRelatorio} disabled={loading}>
                {loading ? 'Gerando...' : 'Gerar Relatório'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatorioFinanceiro;
